<template>
    <div class="px-4 py-5 sm:p-6 bg-white shadow sm:rounded-lg space-y-6">
        <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
                <slot name="title"/>
            </h3>
            <p class="mt-1 text-sm text-gray-500"><slot name="description"/></p>
        </div>
        <slot name="content"></slot>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetSectionTitle from './SectionTitle.vue'

    export default defineComponent({
        components: {
            JetSectionTitle,
        }
    })
</script>
